import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function PrivateRoute({ children }) {
  const isloggedIn = useAuth();
  const auth = useSelector((state) => state.auth);

  return isloggedIn ? (
    auth.user.role === "student" ? (
      // if logged in but user is a student then show the page
      children
    ) : (
      // if logged in but user is an admin then show admin dashboard page
      <Navigate to="/admin/dashboard" />
    )
  ) : (
    // if not logged in then show the page student login page
    <Navigate to="/" />
  );
}
